import directTeams from "../data/directTeams.json";
import { Team } from "../types/team";
import TeamLogo from "./TeamLogo";

type Props = {
  onTeamSelect: (team: Team) => void;
};

const POT_STYLES: Record<1 | 2 | 3 | 4, { border: string; badge: string; label: string }> = {
  1: { border: "border-yellow-400/60", badge: "bg-yellow-400 text-yellow-950", label: "Pot 1" },
  2: { border: "border-slate-300/60", badge: "bg-slate-300 text-slate-900", label: "Pot 2" },
  3: { border: "border-amber-700/60", badge: "bg-amber-700 text-amber-50", label: "Pot 3" },
  4: { border: "border-white/20", badge: "bg-white/30 text-white", label: "Pot 4" }
};

export default function TeamSelector({ onTeamSelect }: Props) {
  const teams = directTeams as Team[];

  const renderTeamCard = (team: Team, index: number) => {
    const pot = POT_STYLES[team.pot];
    return (
      <div
        key={index}
        onClick={() => onTeamSelect(team)}
        className={`p-4 rounded-xl shadow-md cursor-pointer hover:shadow-lg flex items-center space-x-4
               bg-white/10 backdrop-blur border ${pot.border} hover:bg-white/20 transition`}
      >
        <TeamLogo logo={team.logo} name={team.name} className="w-12 h-12" />
        <div className="text-white flex-1">
          <strong>{team.name}</strong> ({team.country})
        </div>
        <span className={`text-xs font-bold px-2 py-1 rounded ${pot.badge}`}>{pot.label}</span>
      </div>
    );
  };

  return (
    <div className="p-8 relative z-10 text-white">
      <h2 className="text-3xl font-extrabold mb-6 text-white drop-shadow-lg text-center">
        Takım Seç
      </h2>

      <h3 className="text-2xl font-semibold mt-10 mb-4 text-pink-300 drop-shadow">
        🎯 Lig Aşamasındaki Takımlar
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {teams.map((team, idx) => renderTeamCard(team, idx))}
      </div>
    </div>
  );
}
